import '@emotion/react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "iuz0zb",
  styles: "overflow-y:auto;list-style:none"
} : {
  name: "dpbaso-getListStyles",
  styles: "overflow-y:auto;list-style:none;label:getListStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxpc3RTdHlsZXMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdJIiwiZmlsZSI6Ikxpc3RTdHlsZXMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBTZXJpYWxpemVkU3R5bGVzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5leHBvcnQgY29uc3QgZ2V0TGlzdFN0eWxlcyA9ICgpOiBTZXJpYWxpemVkU3R5bGVzID0+XG4gICAgY3NzKHtcbiAgICAgICAgb3ZlcmZsb3dZOiAnYXV0bycsXG4gICAgICAgIGxpc3RTdHlsZTogJ25vbmUnLFxuICAgIH0pO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const getListStyles = () => _ref;

export { getListStyles };
//# sourceMappingURL=ListStyles.js.map
